import {
    useStyles,
    MobileHeaderSection,
    pxToRem,
    pxArrayToRem,
    Button,
} from '@archipro-design/aria';

import { useCurrentTabPath } from '@modules/professional/hook/use-current-tab-path';

import * as S from './MobileHeader.style';
import { Link } from '@remix-run/react';
import { ChevronDown } from '@archipro-design/icons';

interface MobileHeaderProps {
    title?: string;
    subtitle: string;
    customBackUrl?: string;
    backLinkText?: string;
}

const MobileHeader = ({
    subtitle,
    title,
    customBackUrl,
    backLinkText = 'Design boards',
}: MobileHeaderProps) => {
    const { css } = useStyles();

    const currentTabPath = useCurrentTabPath();

    return (
        <div className={css(S.MobileHeader)}>
            {customBackUrl && (
                <div className={css(S.MobileHeaderBackSection)}>
                    <Button
                        as={Link}
                        to={customBackUrl}
                        size={14}
                        transparent={true}
                        icon={<ChevronDown />}
                        variables={{
                            buttonPadding: '0',
                        }}
                    >
                        {backLinkText}
                    </Button>
                </div>
            )}
            <MobileHeaderSection
                subtitle={subtitle}
                title={{
                    children: title || 'Design Boards',
                    variables: {
                        fontSize: pxToRem(20),
                        letterSpacing: 'normal',
                    },
                }}
                className={currentTabPath}
                variables={{
                    contentPadding: pxArrayToRem([48, 18, 0, 18]),
                    marginBottomHeadings: pxToRem(10),
                }}
            />
        </div>
    );
};

export default MobileHeader;
